import React from 'react';

const CanvasContext = React.createContext();

export default CanvasContext;
